export default {
  haulers: 'Vognmænd',
  setup: 'Indstillinger',
  driverExperience: 'Chauffør Erfaring',
  users: 'Brugere',
};
